import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_31PaginaActiva,
    ObtenerClientePorLogin31,
    obtenerContadorDeFechaFolio,
    registrarSolicitudFC_31Accion,
    eliminarFC_31AnexoMuestreoBD,
    eliminarFC_31AnexoIngresoBD,
    eliminarFC_31AnexoLiberacionBD,
    actualizarFC_31Solicitud,

    actualizarFC_31Estatus,
    resetDataFC_31,
    actualizarFC_31SolicitudBorrador,
    agregarFC_31SolicitudBorrador,
} from '../../../redux/DucksBeneficiario/FC_31Ducks'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC31BeneficiarioComponent.module.css';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import TablaProductoMuestreo from './TablaProductoMuestreo';
import TablaProductoIngresoMaduracion from '../FormularioFC31/TablaProductoIngresoMaduracion';
import TablaProductoLiberacionMaduracion from '../FormularioFC31/TablaProductoLiberacionMaduracion';
const { useEffect, useRef } = React;
import { Formik } from 'formik'
import id from 'date-fns/esm/locale/id/index.js';
import DocumentacionFC_31Component from './DocumentacionFC_31Component';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC31BeneficiarioComponent(props) {
    const dispatch = useDispatch()
    const [alert, setAlert] = useStateIfMounted(false)
    const [errorAgregar, setErrorAgregar] = useStateIfMounted(false)
    const [exito, setExito] = useStateIfMounted(false)

    var fechaHoy = moment().format('YYYY-MM-DD');
    const fc_31ProductosAjusteMap = []
    const usuario = useSelector(store => store.Usuario)
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    const [folio, setFolio] = React.useState('')

    const idUsuario = usuario.data.user[0].id
    const currentUser = useSelector(store => store.Usuario.data)
    let fc_31 = useSelector(store => store.FC_31Solicitud.fc_31)
    let fc_31Muestreo = useSelector(store => store.FC_31Solicitud.anexoMuestreo)
    let fc_31Ingreso = useSelector(store => store.FC_31Solicitud.anexoIngreso)
    let fc_31Liberacion = useSelector(store => store.FC_31Solicitud.anexoLiberacion)
    let fc_31Map = useSelector(store => store.FC_31Solicitud.fc_31Map)
    let fc_31MuestreoMap = useSelector(store => store.FC_31Solicitud.anexosMuestreoMap)
    let fc_31IngresosMap = useSelector(store => store.FC_31Solicitud.anexosIngresoMap)
    let fc_31LiberacionMap = useSelector(store => store.FC_31Solicitud.anexosLiberacionMap)
    let filesMuestreoMap = useSelector(store => store.FC_31Solicitud.filesMuestreoMap)
    let filesIngresoMap = useSelector(store => store.FC_31Solicitud.filesIngresoMap)
    let dataCliente = useSelector(store => store.FC_31Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_31Solicitud.dataLogin)
    let instalacionesCliente = useSelector(store => store.FC_31Solicitud.instalacionesCliente)
    const modoEdicionBorrador = useSelector(store => store.FC_31Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_31Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_31Solicitud.data)
    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin31({ idlogin: usuario.data.user[0].id }))
    }, [])

    /*Controlar las el formulario con las paginas*/
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Documentación'])
    const paginaActiva = useSelector(store => store.FC_31Solicitud.paginaActiva)


    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [numerocliente, setnumerocliente] = useStateIfMounted(0)
    const [fechapropuesta, setfechapropuesta] = useStateIfMounted(fechaHoy)
    const [responsableinstalacion, setresponsableinstalacion] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const [telefono, settelefono] = useStateIfMounted('')
    const [calle, setcalle] = useStateIfMounted('')
    const [idestatusdesolicitudes, setidestatusdesolicitudes] = useStateIfMounted(2)
    const [ajustedegrado, setajustedegrado] = useStateIfMounted(false)
    const [muestra, setmuestra] = useStateIfMounted(false)
    const [muestreo, setmuestreo] = useStateIfMounted(false)
    const [ingresomaduracion, setingresomaduracion] = useStateIfMounted(false)
    const [liberacionmaduracion, setliberacionmaduracion] = useStateIfMounted(false)
    const [idfc31_solicitudseguimiento, setidfc31_solicitudseguimiento] = useStateIfMounted(0)
    const idfc31_solicitudseguimientoRef = useRef(idfc31_solicitudseguimiento)

    const [idlogin, setidlogin] = useStateIfMounted(idUsuario)

    const [ajustesDeGradoAEliminar, setAjustesDeGradoAEliminar] = useStateIfMounted([])
    const [mezclasYMuestreosAEliminar, setMezclasYMuestreosAEliminar] = useStateIfMounted([])
    const [ingresosAEliminar, setIngresosAEliminar] = useStateIfMounted([])
    const [ajustesGrado, setAjustesGrado] = useStateIfMounted([]);
    const [mezclasYMuestreo, setMezclasYMuestreo] = useStateIfMounted([])

    const store = useSelector(store => store)
    /*React.useEffect(() => {
        let totalDePaginas = 2
        const nuevosApartados = ['Datos generales']
        if (ingresomaduracion || liberacionmaduracion) {
            totalDePaginas++
            let nombreApartado = 'Maduración'
            nuevosApartados.push(nombreApartado)
        }
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [ingresomaduracion, liberacionmaduracion])*/

    const noActualizarBorrador = useRef(true)
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_31 = data
            setingresomaduracion(fc_31.ingresomaduracion)
            setliberacionmaduracion(fc_31.liberacionmaduracion)
        }
    }, [fc_31, data])

    React.useEffect(() => {
        if (fc_31Muestreo) {
            setProductosMuestreo(fc_31Muestreo)
        } else {
            setProductosMuestreo(fc_31Muestreo)
        }
    }, [fc_31Muestreo])

    React.useEffect(() => {
        if (fc_31Ingreso) {
            setProductosIngreso(fc_31Ingreso)
        } else {
            setProductosIngreso(fc_31Ingreso)
        }
    }, [fc_31Ingreso])

    React.useEffect(() => {
        if (fc_31Liberacion) {
            setProductosLiberacion(fc_31Liberacion)
        } else {
            setProductosLiberacion(fc_31Liberacion)
        }
    }, [fc_31Liberacion])

    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarSolicitudFC_31':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarSolicitudBorradorFC_31':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarBorrador':
                                        enviarBorrador()
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const handleResetAllPropertys = () => {
        dispatch(resetDataFC_31())
        //productos([])
        handleCloseModal()
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudFC_31 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_31'
        })
    }
    const botonEnviarSolicitudBorradorFC_31 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_31'
        })
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_31 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }

    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechapropuesta = new Date(valores.fechapropuesta).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            fechapropuesta: fechapropuesta,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        let objetoCompleto = {
            solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
        }
        const resultado = await dispatch(registrarSolicitudFC_31Accion(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_31())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }

    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechapropuesta = new Date(valores.fechapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc31_solicitudseguimiento: data.idfc31_solicitudseguimiento,
            fechapropuesta: fechapropuesta,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
            idestatusdesolicitudes: 1,
        }
        let objetoCompleto = {
            solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
        }
        const resultado = await dispatch(actualizarFC_31Solicitud(objetoCompleto))

        await dispatch(actualizarLoadingApp_false())
        await dispatch(resetDataFC_31())
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }

    const botonRegistrarFC_31 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechapropuesta = new Date(valores.fechapropuesta).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        if(valores.liberacionmaduracion){
            const solicitud = {
                fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
                fechapropuesta: fechapropuesta, tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
                correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
                muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
                idestatusdesolicitudes: 2, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            }
            let objetoCompleto = {
                solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
            }
            const resultado = await dispatch(registrarSolicitudFC_31Accion(objetoCompleto))
            await dispatch(actualizarLoadingApp_false())
            setFolio(consFolio)
            setEnvioCorrecto(true)
            await dispatch(resetDataFC_31())
            functionResetForm.function()
            
            /*await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')*/
        }else{
            const solicitud = {
                fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
                fechapropuesta: fechapropuesta, tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
                correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
                muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
                idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            }
            let objetoCompleto = {
                solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
            }
            const resultado = await dispatch(registrarSolicitudFC_31Accion(objetoCompleto))
            await dispatch(actualizarLoadingApp_false())
            await dispatch(resetDataFC_31())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
        
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechapropuesta = new Date(valores.fechapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc31_solicitudseguimiento: data.idfc31_solicitudseguimiento,
            fechapropuesta: fechapropuesta,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
            idestatusdesolicitudes: 6,
        }
        let objetoCompleto = {
            solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
        }
        await dispatch(actualizarFC_31Solicitud(objetoCompleto))
        const idSolicitud = data.idfc31_solicitudseguimiento
        const estatusNuevo = 6
        const idCliente = dataCliente.idcliente
        const tablaFC_31 = 6
        const tabla = tablaFC_31
        await dispatch(actualizarFC_31Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_31())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }

    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechapropuesta = new Date(valores.fechapropuesta).toISOString()

        const solicitud = {
            fechasolicitud: fechaSolicitud, idfc31_solicitudseguimiento: data.idfc31_solicitudseguimiento,
            fechapropuesta: fechapropuesta,
            tipoinstalacion: valores.tipoinstalacion, responsableinstalaciones: valores.responsableinstalaciones,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono, domicilio: valores.domicilio,
            muestreo: valores.muestreo, ingresomaduracion: valores.ingresomaduracion, liberacionmaduracion: valores.liberacionmaduracion,
            idestatusdesolicitudes: 7,
        }
        let objetoCompleto = {
            solicitud: solicitud, muestreo: productosMuestreo, ingreso: productosIngreso, liberacion: productosLiberacion
        }
        const resultado = await dispatch(actualizarFC_31Solicitud(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc31_solicitudseguimiento
            const estatusNuevo = 7
            const idCliente = dataCliente.idcliente//null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_31 = 6
            const tabla = tablaFC_31
            await dispatch(actualizarFC_31Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_31())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const paginaAnterior = async () => {
        dispatch(actualizarFC_31PaginaActiva(paginaActiva - 1))
    }
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_31PaginaActiva(paginaActiva + 1))
        }
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    const [productosMuestreo, setProductosMuestreo] = React.useState([])
    const handdleProductoMuestreo = async (objectProducto) => {
        await setProductosMuestreo(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrevMuestreo = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexomuestreo) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc31_anexomuestreo))
        }
        const filtro = productosMuestreo.filter(anexo => anexo.id !== objectProducto.data.id)
        await setProductosMuestreo(filtro)

    }
    const handdleEditProductosPrevMuestreo = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_31MuestreoMap.length > 0) {
            const filtro = productosMuestreo.findIndex(anexo => anexo.idfc31_anexomuestreo === objectProducto.id)
            let editar = { ...productosMuestreo[Number(filtro)] }
            const filtroEliminar = productosMuestreo.filter(anexo => anexo.idfc31_anexomuestreo !== objectProducto.id)
            editar.numerolote = objectProducto.numerolote
            editar.volumen = objectProducto.volumen
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.analisis = objectProducto.analisis
            editar.mezcla = objectProducto.mezcla
            editar.ajuste = objectProducto.ajuste
            editar.informacionadicional = objectProducto.informacionadicional
            filtroEliminar.push(editar)
            await setProductosMuestreo(filtroEliminar)
        } else {
            const filtro = productosMuestreo.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productosMuestreo
            const newProductos = []
            for (const i in productosMuestreo) {
                const { ...restProducto } = productosMuestreo[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].volumen = objectProducto.volumen
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].ajuste = objectProducto.ajuste
            newProductos[Number(filtro)].mezcla = objectProducto.mezcla
            newProductos[Number(filtro)].analisis = objectProducto.analisis
            newProductos[Number(filtro)].informacionadicional = objectProducto.informacionadicional
            await setProductosMuestreo(newProductos)
        }
    }

    //esto es para Ingreso maduración
    const [productosIngreso, setProductosIngreso] = React.useState([])
    const handdleProductoIngreso = (objectProducto) => {
        setProductosIngreso(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrevIngreso = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexoingresomaduracion) {
            await dispatch(eliminarFC_31AnexoIngresoBD(objectProducto.data.idfc31_anexoingresomaduracion))
        }
        const filtro = productosIngreso.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductosIngreso(filtro)

    }
    const handdleEditProductosPrevIngreso = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_31IngresosMap.length > 0) {
            const filtro = productosIngreso.findIndex(anexo => anexo.idfc31_anexoingresomaduracion === objectProducto.id)
            let editar = { ...productosIngreso[Number(filtro)] }
            const filtroEliminar = productosIngreso.filter(anexo => anexo.idfc31_anexoingresomaduracion !== objectProducto.id)
            editar.numerolote = objectProducto.numerolote
            editar.fechaingreso = objectProducto.fechaingreso
            editar.numeroanalisis = objectProducto.numeroanalisis
            editar.informacionadicional = objectProducto.informacionadicional
            editar.volumen = objectProducto.volumen
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            filtroEliminar.push(editar)
            setProductosIngreso(filtroEliminar)
        } else {
            const filtro = productosIngreso.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productosIngreso
            const newProductos = []
            for (const i in productosIngreso) {
                const { ...restProducto } = productosIngreso[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].fechaingreso = objectProducto.fechaingreso
            newProductos[Number(filtro)].numeroanalisis = objectProducto.numeroanalisis
            newProductos[Number(filtro)].informacionadicional = objectProducto.informacionadicional
            newProductos[Number(filtro)].volumen = objectProducto.volumen
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            setProductosIngreso(newProductos)
        }
    }
    //esto es para Liberacion maduración
    const [productosLiberacion, setProductosLiberacion] = React.useState([])
    const handdleProductoLiberacion = (objectProducto) => {
        setProductosLiberacion(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrevLiberacion = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexoliberacionmaduracion) {
            await dispatch(eliminarFC_31AnexoLiberacionBD(objectProducto.data.idfc31_anexoliberacionmaduracion))
        }
        const filtro = productosLiberacion.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductosLiberacion(filtro)

    }
    const handdleEditProductosPrevLiberacion = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_31LiberacionMap.length > 0) {
            const filtro = productosLiberacion.findIndex(anexo => anexo.idfc31_anexoliberacionmaduracion === objectProducto.id)
            let editar = { ...productosLiberacion[Number(filtro)] }
            const filtroEliminar = productosLiberacion.filter(anexo => anexo.idfc31_anexoliberacionmaduracion !== objectProducto.id)
            editar.numerorecipientes = objectProducto.numerorecipientes
            editar.materialrecipientes = objectProducto.materialrecipientes
            editar.capacidad = objectProducto.capacidad
            editar.informacionadicional = objectProducto.informacionadicional
            editar.numerolote = objectProducto.numerolote
            editar.volumen = objectProducto.volumen
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.unidad = objectProducto.unidad
            filtroEliminar.push(editar)
            setProductosLiberacion(filtroEliminar)
        } else {
            const filtro = productosLiberacion.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productosLiberacion
            const newProductos = []
            for (const i in productosLiberacion) {
                const { ...restProducto } = productosLiberacion[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].numerorecipientes = objectProducto.numerorecipientes
            newProductos[Number(filtro)].materialrecipientes = objectProducto.materialrecipientes
            newProductos[Number(filtro)].capacidad = objectProducto.capacidad
            newProductos[Number(filtro)].informacionadicional = objectProducto.informacionadicional
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].volumen = objectProducto.volumen
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].unidad = objectProducto.unidad
            setProductosLiberacion(newProductos)
        }
    }
    const setDatos = (datos) => {
        let dato = datos.split('/')
        let alias = Number(dato[1])
        let tipoanexo = Number(dato[0])
        if(dato[0] != '1' && dato[0] != '2') {
            let corte = dato[0].split('-')
            tipoanexo = Number(corte[0])
        }
        for (let dato in instalacionesCliente) {
            if (instalacionesCliente?.[dato]?.idanexocliente == alias && instalacionesCliente?.[dato]?.idtipoanexo == tipoanexo) {
                const telefono = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].telefono
                const correoelectronico = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].correoelectronico
                const responsableinstalaciones = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].nombreresponsable
                let numeroint = ''
                let numeroext = ''
                if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === null ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === undefined ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === '') numeroint = 's/n'
                else { numeroint = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior }
                if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === null ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === undefined ||
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === '') numeroext = 's/n'
                else { numeroext = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior }
                const domicilio = instalacionesCliente[dato].informaciongeneralinstalacioncliente.calle + ',' +
                    numeroint + ',' + numeroext + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.colonia + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.localidad + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.municipio + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.estado + ',' +
                    instalacionesCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                return { responsableinstalaciones, telefono, correoelectronico, domicilio }
            }
        }
        return { responsableinstalaciones: '', telefono: '', correoelectronico: '', domicilio: '' }
    }
    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const textoChecks = 'Debe de seleccionar solo una opción'
        const texto = 'Campo Obligatorio'
        if (paginaActiva === 1) {
            if (!values.fechapropuesta) { errores.fechapropuesta = texto }
            if (!values.tipoinstalacion) { errores.tipoinstalacion = texto }
            if (!values.responsableinstalaciones) { errores.responsableinstalaciones = texto }
            if (!values.correoelectronico) { errores.correoelectronico = texto }
            if (!values.telefono) { errores.telefono = texto }
            if (!values.domicilio) { errores.domicilio = texto }
            if (!values.muestreo && !values.ingresomaduracion && !values.liberacionmaduracion) { errores.actividad = textoCheck }
            if (values.muestreo) {
                if (productosMuestreo.length <= 0) { errores.productoM = 'Debe de agregar un producto de muestreo' }
            }
        }
        if (paginaActiva === 2) {
            if (values.ingresomaduracion) { if (productosIngreso.length <= 0) errores.ingresoM = 'Debe de agregar un producto de ingreso a maduración' }
            if (values.liberacionmaduracion) { if (productosLiberacion.length <= 0) errores.liberacionM = 'Debe de agregar un producto de liberacion de maduración' }
        }
        return errores;
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_31
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_31(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row'>
                                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de seguimiento'} />
                                </div>
                                {
                                    !modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                        <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                            aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                botonGuardarComoBorrador(values)}
                                        >
                                            <SaveIcon />
                                            {
                                                modoEdicionBorrador ? (
                                                    <div className="badge text-dark textoNormal textoModal">
                                                        Guardar cambios en borrador
                                                    </div>) : (
                                                    <div className="badge text-dark textoNormal textoModal">
                                                        Guardar como borrador
                                                    </div>
                                                )
                                            }
                                        </IconButton>
                                    </div>
                                }
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center">
                                    <h1></h1>
                                </div>
                                {
                                    !modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center marginsitoTop">
                                        <Fragment>
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() =>
                                                    botonReiniciarFormato()}
                                            >
                                                <FormatClearIcon />
                                                <div className="badge text-dark textoNormal textoModal">Reiniciar Formato </div>
                                            </IconButton>
                                        </Fragment>
                                    </div>
                                }

                                <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-3 text-center">
                                    <h1></h1>
                                </div>
                            </div>
                            {
                                nombresParaPaginas[paginaActiva - 1] === 'Datos generales' ?
                                    <div className='row justify-content-start'>

                                        <div className={`text-center ${estilos.labelNaranja} mt-3`}>
                                            <h6 className={`text-center `}>DESCRIPCIÓN DEL SERVICIO SOLICITADO </h6>
                                        </div>
                                        <div className={`row  ${estilos.divSoloBorderNaranja} mt-1`}>
                                            <small className='text-center '>INSPECCIÓN DURANTE LAS SIGUIENTES ACTIVIDADES</small>
                                            <div className='col-md-4'>
                                                <input className={`form-check-input me-1 ${fc_31Map.muestreocheck !== undefined ? (
                                                    fc_31Map?.muestreocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.muestreo} id='mezcla'
                                                    name="muestreo"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.muestreo = e.target.checked
                                                        newValues.liberacionmaduracion = false
                                                        newValues.ingresomaduracion = false
                                                        setValues(newValues)
                                                        setingresomaduracion(false)
                                                        setliberacionmaduracion(false)
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <label className='text-center'>Muestreo</label><br />
                                                <span className='text-danger'>{fc_31Map?.muestreocheck ? fc_31Map?.muestreo : ''}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                <input className={`form-check-input me-1 ${fc_31Map.ingresomaduracioncheck !== undefined ? (
                                                    fc_31Map?.ingresomaduracioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.ingresomaduracion} id='ingresomaduracion'
                                                    name="ingresomaduracion"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.ingresomaduracion = e.target.checked
                                                        newValues.liberacionmaduracion = false
                                                        newValues.muestreo = false
                                                        setValues(newValues)
                                                        setingresomaduracion(e.target.checked)
                                                        setliberacionmaduracion(false)
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                    Ingreso a maduración
                                                </label>
                                                <span className='text-danger'>{fc_31Map?.ingresomaduracioncheck ? fc_31Map?.ingresomaduracion : ''}</span>
                                            </div>
                                            <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                <input className={`form-check-input me-1 ${fc_31Map.liberacionmaduracioncheck !== undefined ? (
                                                    fc_31Map?.liberacionmaduracioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.liberacionmaduracion} id='liberacionmaduracion'
                                                    name="liberacionmaduracion"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.liberacionmaduracion = e.target.checked
                                                        newValues.muestreo = false
                                                        newValues.ingresomaduracion = false
                                                        setValues(newValues)
                                                        setliberacionmaduracion(e.target.checked)
                                                        setingresomaduracion(false)
                                                    }} onBlur={handleBlur} />

                                                <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                    Liberación de maduración
                                                </label><br />
                                                <span className='text-danger'>{fc_31Map?.liberacionmaduracioncheck ? fc_31Map?.liberacionmaduracion : ''}</span>
                                            </div>
                                            {touched.liberacionmaduracion && errors.liberacionmaduracion && <div className="text-danger">{errors.liberacionmaduracion}</div>}
                                        </div>

                                        <div className={`text-center ${estilos.labelNaranja} mt-3`}>
                                            <h6 className={`text-center `}>INFORMACIÓN DEL SOLICITANTE</h6>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-3">
                                                <input type="date" className={`form-control ${fc_31Map.fechapropuestacheck !== undefined ? (
                                                    fc_31Map?.fechapropuestacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='Fecha de termino' min={fechaHoy}
                                                    name="fechapropuesta"
                                                    value={values.fechapropuesta}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <label htmlFor='floatingInput'>Fecha de visita propuesta</label>
                                                <span className='text-danger'>{fc_31Map?.fechapropuestacheck ? fc_31Map?.fechapropuesta : ''}</span>
                                                {touched.fechapropuesta && errors.fechapropuesta && <div className="text-danger">{errors.fechapropuesta}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-6">
                                                <select className={`form-select ${fc_31Map.tipoinstalacioncheck !== undefined ?
                                                    (fc_31Map?.tipoinstalacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    name="tipoinstalacion"
                                                    value={values.tipoinstalacion}
                                                    onChange={e => {
                                                        const result = setDatos(e.target.value)
                                                        const { ...newValues } = values
                                                        //const cortar = e.target.value.split('/')
                                                        newValues.tipoinstalacion = e.target.value
                                                        if (result !== '') {
                                                            newValues.responsableinstalaciones = result.responsableinstalaciones
                                                            newValues.correoelectronico = result.correoelectronico
                                                            newValues.telefono = result.telefono
                                                            newValues.domicilio = result.domicilio
                                                        }
                                                        setValues(newValues)
                                                    }} onBlur={handleBlur} >
                                                    <option value="">Seleccione un tipo de instalación</option>

                                                    {instalacionesCliente?.map((opcion, index) => (
                                                        <option value={`${opcion.idtipoanexo === 1 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 2 ? opcion.idtipoanexo + '/' + opcion.idanexocliente : opcion.idtipoanexo === 3 ? opcion.idtipoanexo + '-' +opcion.secciones+ '/' + opcion.idanexocliente : 'Domicilio Fiscal'}`} >
                                                            {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? 'Unidad Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? 'Unidad Almacén: ' + opcion.secciones + ': ' + opcion.informaciongeneralinstalacioncliente.alias : 'Domicilio Fiscal'}`}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                <span className='text-danger'>{fc_31Map?.tipoinstalacioncheck === true ? fc_31Map?.tipoinstalacion : ''}</span>
                                                {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_31Map.responsableinstalacionescheck !== undefined ? (
                                                    fc_31Map?.responsableinstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    placeholder='responsableinstalaciones'
                                                    name="responsableinstalaciones"
                                                    value={values.responsableinstalaciones}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <label htmlFor="floatingInput">Responsable de las instalación</label>
                                                <span className='text-danger'>{fc_31Map?.responsableinstalacionescheck ? fc_31Map?.responsableinstalaciones : ''}</span>
                                                {touched.responsableinstalaciones && errors.responsableinstalaciones && <div className="text-danger">{errors.responsableinstalaciones}</div>}
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_31Map.correoelectronicocheck !== undefined ? (
                                                    fc_31Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    placeholder='correoelectronico'
                                                    name="correoelectronico"
                                                    value={values.correoelectronico}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <label htmlFor="floatingInput">Correo electrónico</label>
                                                <span className='text-danger'>{fc_31Map?.correoelectronicocheck ? fc_31Map?.correoelectronico : ''}</span>
                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_31Map.telefonocheck !== undefined ? (
                                                    fc_31Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    placeholder='telefono'
                                                    name="telefono"
                                                    value={values.telefono}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <label htmlFor="floatingInput">Teléfono</label>
                                                <span className='text-danger'>{fc_31Map?.telefonocheck ? fc_31Map?.telefono : ''}</span>
                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                            </div>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_31Map.domiciliocheck !== undefined ? (
                                                    fc_31Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    placeholder='domicilio'
                                                    name="domicilio"
                                                    value={values.domicilio}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <label htmlFor="floatingInput">Domicilio de las instalaciones donde se encuentra el producto</label>
                                                <span className='text-danger'>{fc_31Map?.domiciliocheck ? fc_31Map?.domicilio : ''}</span>
                                                {touched.domicilio && errors.domicilio && <div className="text-danger">{errors.domicilio}</div>}
                                            </div>
                                        </div>
                                        {values.muestreo && <Fragment>
                                            <div className={`text-center ${estilos.labelNaranja} mt-2`}>
                                                <label className='text-center'>Muestreo</label>
                                            </div>
                                            <TablaProductoMuestreo api={{ handdleProductoMuestreo, handdleRemoveProductosPrevMuestreo, handdleEditProductosPrevMuestreo, productosMuestreo }} productosMap={fc_31MuestreoMap} />
                                        </Fragment>}
                                        {values.ingresomaduracion && <Fragment>
                                            <div className={`row text-center  ${estilos.labelNaranja} mt-3`}>
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                    <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                        Ingreso a maduración
                                                    </label>
                                                </div>
                                            </div>
                                            <TablaProductoIngresoMaduracion api={{ handdleProductoIngreso, handdleRemoveProductosPrevIngreso, handdleEditProductosPrevIngreso, productosIngreso }} productosMap={fc_31IngresosMap} ></TablaProductoIngresoMaduracion>
                                        </Fragment>}
                                        {values.liberacionmaduracion && <Fragment>
                                            <div className={`row text-center  ${estilos.labelNaranja} mt-3`}>
                                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                    <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                        Liberación de maduración
                                                    </label>
                                                </div>
                                            </div>
                                            <TablaProductoLiberacionMaduracion api={{ handdleProductoLiberacion, handdleRemoveProductosPrevLiberacion, handdleEditProductosPrevLiberacion, productosLiberacion }} productosMap={fc_31LiberacionMap} ></TablaProductoLiberacionMaduracion>
                                        </Fragment>}
                                    </div>
                                    : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                        <Fragment>
                                            {modoCorreccion &&
                                                <div className={`row col-md-12`} style={{ marginLeft: '-9%' }}>
                                                    <DocumentacionFC_31Component />
                                                </div>
                                            }
                                            <div className='row justify-content-start'>
                                                <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_31'} />
                                            </div>
                                            <br />
                                            <br />
                                            {!modoCorreccion ?
                                                <div>
                                                    <div className="row mt-4">
                                                        {modoEdicionBorrador ?
                                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                                <button type="submit"
                                                                    onClick={() => { botonEnviarSolicitudBorradorFC_31(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                    className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                    disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                            </div> :
                                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                                <button type="submit"
                                                                    onClick={() => { botonEnviarSolicitudFC_31(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                    className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                    disabled={!terminosYCondiciones}>Enviar</button>
                                                            </div>
                                                        }
                                                    </div>
                                                </div> :
                                                <div className="row mt-4">
                                                    <div className="d-grid gap-2 col-2 mx-auto">
                                                        <button type="submit"
                                                            onClick={() => { botonEnviarCorreccionesFC_31(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                            className={`btn ${estilos.botonNaranjaRedondo}`} disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                                    </div>
                                                </div>
                                            }
                                        </Fragment> : ''
                            }
                            <br />  <br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
                        </div >
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}
export default withRouter(FormularioFC31BeneficiarioComponent)